import { Axios, RestAxios } from '../utils/Axios'

// 根据订单号校验是否存在可分析的ab1文件
export const canAnalysisAb1ByCode = (data) => {
	return RestAxios.post(`official-tools/can-analysis`, data)
}
// Sanger测序-序列拼接
// Sanger测序-序列拼接-订单号维度
export const seqJoinByCode = (data) => {
	return RestAxios.post(`official-tools/seq-join/analysis-by-code`, data)
}
// Sanger测序-序列拼接-ab1维度
export const seqJoinByFile = (data) => {
	return RestAxios({
		url: `official-tools/seq-join/analysis-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// Sanger测序-序列拼接-分页列表查询
export const seqJoinByPage = (params) => {
	return RestAxios.get(`official-tools/seq-join/page`, { params })
}
// Sanger测序-序列拼接-下载文件
export const seqJoinDownload = (reqId, params) => {
	return RestAxios({
		url: `official-tools/seq-join/${reqId}/download`,
		responseType: 'blob',
		method: 'get',
		params,
	})
}
// Sanger测序-峰图
// Sanger测序-峰图-订单号维度
export const mountainPicByCode = (data) => {
	return RestAxios.post(`official-tools/mountain-pic/analysis-by-code`, data)
}
// Sanger测序-峰图-ab1维度
export const mountainPicByFile = (data) => {
	return RestAxios({
		url: `official-tools/mountain-pic/analysis-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// Sanger测序-峰图-分页列表查询
export const mountainPicByPage = (params) => {
	return RestAxios.get(`official-tools/mountain-pic/page`, { params })
}
// Sanger测序-峰图-下载文件
export const mountainPicDownload = (reqId, params) => {
	return RestAxios({
		url: `official-tools/mountain-pic/${reqId}/download`,
		responseType: 'blob',
		method: 'get',
		params,
	})
}
// Sanger测序-导出ab1分析报告
// Sanger测序-导出ab1分析报告-订单号维度
export const ab1ReportByCode = (data) => {
	return RestAxios.post(`official-tools/ab1-report/analysis-by-code`, data)
}
// Sanger测序-导出ab1分析报告-ab1维度
export const ab1ReportByFile = (data) => {
	return RestAxios({
		url: `official-tools/ab1-report/analysis-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// Sanger测序-导出ab1分析报告-下载文件
export const ab1ReportDownload = (reqId, params) => {
	return RestAxios({
		url: `official-tools/ab1-report/${reqId}/download`,
		responseType: 'blob',
		method: 'get',
		params,
	})
}
// Sanger测序-SNP分析
// Sanger测序-SNP分析-订单号维度
export const fixedPositionByCode = (data) => {
	return RestAxios.post(`official-tools/fixed-position/list-by-code`, data)
}
// Sanger测序-SNP分析-ab1维度
export const fixedPositionByFile = (data) => {
	return RestAxios({
		url: `official-tools/fixed-position/list-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// Sanger测序-SNP分析-分页列表查询
export const fixedPositionByPage = (params) => {
	return RestAxios.get(`official-tools/fixed-position/page`, { params })
}
// Sanger测序-SNP分析-开始分析
export const fixedPositionAnalysis = (reqId, data) => {
	return RestAxios.post(`official-tools/fixed-position/${reqId}/analysis`, data)
}
// Sanger测序-SNP分析-下载文件
export const fixedPositionDownload = (reqId, data) => {
	return RestAxios({
		url: `official-tools/fixed-position/${reqId}/download`,
		responseType: 'blob',
		method: 'post',
		data,
	})
}

// 云工具相关
// DNA序列分析-seq文件格式转化
// DNA序列分析-seq文件格式转化-上传文件校验
export const seqFileFormatUpload = (data) => {
	return RestAxios({
		url: `official-tools/seq-file-format/list-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// DNA序列分析-seq文件格式转化-取消转化
export const seqFileFormatCancel = (reqId) => {
	return RestAxios.post(`official-tools/seq-file-format/${reqId}/cancel`)
}
// DNA序列分析-seq文件格式转化-文件转化
export const seqFileFormatTransform = (params) => {
	return RestAxios.post(`official-tools/seq-file-format/${params.reqId}/${params.format}/transform`)
}
// DNA序列分析-seq文件格式转化-取消转化
export const seqFileFormatDownload = (reqId, params) => {
	return RestAxios({
		url: `official-tools/seq-file-format/${reqId}/download`,
		responseType: 'blob',
		method: 'get',
		params,
	})
}

// DNA序列分析-DNA/氨基酸序列转换
// DNA序列分析-DNA/氨基酸序列转换-分析
export const seq2aminoTransform = (data) => {
	return RestAxios({
		url: `official-tools/seq2amino/transform`,
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'post',
		data
	})
}

// DNA序列分析-酶切位点分析
// DNA序列分析-酶切位点分析-分析
export const enzymeCutPosAnalysis = (data) => {
	return RestAxios({
		url: `official-tools/enzyme-cut-pos/analysis`,
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'post',
		data
	})
}
// DNA序列分析-酶切位点分析-下载
export const enzymeCutPosDownload = (reqId) => {
	return RestAxios({
		url: `official-tools/enzyme-cut-pos/${reqId}/download`,
		responseType: 'blob',
		method: 'get'
	})
}

// DNA序列分析-DNA重复&GC含量分析
// DNA序列分析-DNA重复&GC含量分析-通过序列
export const gcContentAnalysisBySeq = (data) => {
	return RestAxios.post(`official-tools/dna-repeat-and-gc-content/analysis-by-seq`, data)
}
// DNA序列分析-DNA重复&GC含量分析-通过文件
export const gcContentAnalysisByFile = (data) => {
	return RestAxios({
		url: `official-tools/dna-repeat-and-gc-content/analysis-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// DNA序列分析-DNA重复&GC含量分析-报告下载
export const gcContentDownload = (reqId) => {
	return RestAxios({
		url: `official-tools/dna-repeat-and-gc-content/${reqId}/download`,
		responseType: 'blob',
		method: 'get'
	})
}
// DNA序列分析-DNA重复&GC含量分析-模板下载
export const gcContentTempDownload = () => {
	return RestAxios({
		url: `official-tools/dna-repeat-and-gc-content/temp-download`,
		responseType: 'blob',
		method: 'get'
	})
}
// DNA序列分析-二级结构分析-分析
export const secondLevelStructureAnalysis = (data) => {
	return RestAxios({
		url: `official-tools/second-level-structure/analysis`,
		headers: { 'Content-Type': 'application/json' },
		responseType: 'blob',
		method: "post",
		data
	})
}

// 序列比对
// 序列比对-根据序列比对
export const DNACompareBySeq = (data) => {
	return RestAxios({
		url: `official-tools/dna-seq-compare/analysis-by-seq`,
		method: 'post',
		data
	})
}
// 序列比对-根据文件比对
export const DNACompareByFile = (data) => {
	return RestAxios({
		url: `official-tools/dna-seq-compare/analysis-by-file`,
		headers: { "Content-Type": "multipart/form-data" },
		method: "post",
		data
	})
}
// 序列比对-模板下载
export const DNACompareTempDownload = () => {
	return RestAxios({
		url: `official-tools/dna-seq-compare/temp-download`,
		responseType: 'blob',
		method: 'get'
	})
}
// 序列比对-报告下载
export const DNACompareDownload = (reqId) => {
	return RestAxios({
		url: `official-tools/dna-seq-compare/${reqId}/download`,
		responseType: 'blob',
		method: 'get'
	})
}
// 序列比对-单个比对结果
export const DNACompareByPage = (params) => {
	return RestAxios.get(`official-tools/dna-seq-compare/page`, { params })
}

// 引物设计
// 引物设计-引物分析工具-分析
export const primerAnalysis = (data) => {
	return RestAxios({
		url: `official-tools/primer-analysis/analysis`,
		headers: { 'Content-Type': 'application/json' },
		method: 'post',
		data
	})
}
// 引物设计-扩增引物设计-分析
export const primerDesign = (data) => {
	return RestAxios({
		url: `official-tools/primer-design/design`,
		method: 'post',
		data
	})
}
// 引物设计-测序引物设计
// 引物设计-测序引物设计-单个
export const seqPrimerDesignBySingle = (data) => {
	return RestAxios({
		url: `official-tools/seq-primer-design/design-by-single`,
		method: 'post',
		data
	})
}
// 引物设计-测序引物设计-测通
export const seqPrimerDesignByTest = (data) => {
	return RestAxios({
		url: `official-tools/seq-primer-design/design`,
		method: 'post',
		data
	})
}
// 引物设计-通用测序引物选择
// 引物设计-通用测序引物选择-查询下拉
export const getSeqPrimerOptions = (name) => {
	return RestAxios.get(`official-tools/common-seq-primer-option/carrier`,{
		params: {
			name,
		}
	})
}
// 引物设计-通用测序引物选择-获取详情
export const getSeqPrimerDetail= (id) => {
	return RestAxios.get(`official-tools/common-seq-primer-option/${id}/detail`)
}



// WEBPACK FOOTER //
// ./src/services/api.tools.js